import { GiftBoxIcon } from "@components/data-display";
import { OnboardMode } from "@constants";
import { getStoredCredential } from "@utils/credentials";
import { Button, cn } from "kz-ui-sdk";
import React from "react";
import { useTranslation } from "react-i18next";

interface OnboardingModeRadioGroupProps {
  value: OnboardMode;
  onChange: (value: OnboardMode) => void;
}

const OnboardingModeRadioGroup: React.FC<OnboardingModeRadioGroupProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const hasSavedPhoneCredentials = !!getStoredCredential().clientId;

  const handleOnClickLogin = () => {
    onChange(OnboardMode.LOGIN);
  };

  const handleOnClickRegister = () => {
    onChange(OnboardMode.REGISTER);
  };

  return (
    <div className="relative flex w-full gap-x-2 rounded-lg bg-white bg-opacity-[0.08] p-1">
      {/* Placeholder text */}
      <div className="absolute start-0 top-0 z-[0] flex h-full w-full items-center justify-center gap-x-2 p-1">
        <div className="flex-1 text-center text-content-soft">{t("Login")}</div>
        <div className="flex flex-1 items-center justify-center gap-x-1 text-center text-content-soft">
          {!hasSavedPhoneCredentials && (
            <GiftBoxIcon
              width={20}
              height={20}
              animated
              shadow
            />
          )}
          {t("register")}
        </div>
      </div>

      <Button
        id="btn-login"
        size="md"
        onClick={handleOnClickLogin}
        variant={"primary"}
        className={cn("z-[1] !rounded", {
          "opacity-100": value === OnboardMode.LOGIN,
          "opacity-0": value === OnboardMode.REGISTER,
        })}
        aria-label="Onboarding mode switch login"
      >
        {t("Login")}
      </Button>
      <Button
        id="btn-register"
        size="md"
        onClick={handleOnClickRegister}
        variant={"primary"}
        className={cn("relative z-[1] !rounded", {
          "opacity-100": value === OnboardMode.REGISTER,
          "opacity-0": value === OnboardMode.LOGIN,
        })}
        aria-label="Onboarding mode switch register"
      >
        {!hasSavedPhoneCredentials && (
          <GiftBoxIcon
            width={20}
            height={20}
            animated
            shadow
            className="-mr-1"
          />
        )}
        {t("register")}
      </Button>
      <span
        className={cn(
          "absolute end-2.5 top-1.5 z-10 text-[9px] font-semibold leading-[12px] tracking-[-0.2px] text-[#E8BC89] transition-opacity",
          {
            "opacity-80": value === OnboardMode.LOGIN,
          },
        )}
      >
        {t("new user")}
      </span>
    </div>
  );
};

export default OnboardingModeRadioGroup;
